import React from "react";
import { useTranslation } from "react-i18next";
import { Profile } from "../../../types/types";

interface SponsorshipsProps {
    member: Profile;
}

const Sponsorships: React.FC<SponsorshipsProps> = ({ member }) => {
    const { t } = useTranslation('publicProfile');
    if (!member.fighter) return null;

    return (
        <div className="space-y-4 pb-8">
            <h3 className="text-base font-semibold text-gray-800 border-b pb-2 text-start">
                {t("sponsorships")}
            </h3>
            <div className="space-y-3">
                {member.fighter?.sponsorsResponseDtos && member.fighter.sponsorsResponseDtos.length > 0 ? (
                    member.fighter.sponsorsResponseDtos.map((sponsor) => (
                        <div
                            key={sponsor.id}
                            className="border rounded-lg p-4 bg-gray-50 flex items-start space-x-4"
                        >
                            {sponsor.logo && (
                                <img
                                    src={sponsor.logo}
                                    alt={sponsor.name}
                                    className="w-16 h-16 object-contain rounded"
                                />
                            )}
                            <div className="flex-1 space-y-1">
                                <h4 className="text-start font-medium text-gray-900">{sponsor.name}</h4>
                                <p className="text-start text-gray-500">{sponsor.description}</p>
                                {sponsor.link && (
                                    <a
                                        href={sponsor.link}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-start text-blue-600 hover:underline text-sm"
                                    >
                                        {sponsor.link}
                                    </a>
                                )}
                            </div>
                        </div>
                    ))
                ) : (
                    <p className="text-gray-500 text-center py-8">
                        {t("no_sponserships")}
                    </p>
                )}
            </div>
        </div>
    );
};

export default Sponsorships;
